import { Route, Redirect } from 'react-router-dom'
import { useUserContext } from '../auth/UserProvider'
import * as routes from '../routes'

const ProtectedRoute = ({
  component: Component,
  allowedUserCodes,
  ...rest
}) => {
  const user = useUserContext()
  return (
    <Route
      {...rest}
      render={props =>
        allowedUserCodes.includes(user.clientCode) ? (
          <Component {...props} />
        ) : (
          <Redirect to={routes.HOME.path} />
        )
      }
    />
  )
}

export default ProtectedRoute
